export default __webpack_public_path__ + "static/media/SCR-20240229-oiij.56ba7df5.png";